module.exports = __webpack_public_path__ + "static/media/calendar.2d63316e.svg";